module.exports = {"411381001":"古城街道","411381002":"花洲街道","411381003":"湍河街道","411381102":"罗庄镇","411381103":"汲滩镇","411381104":"穰东镇","411381105":"孟楼镇","411381106":"林扒镇","411381107":"构林镇","411381108":"十林镇","411381109":"张村镇","411381110":"都司镇","411381111":"赵集镇","411381112":"刘集镇","411381113":"桑庄镇","411381114":"彭桥镇","411381115":"白牛镇","411381116":"腰店镇","411381117":"九龙镇","411381118":"文渠镇","411381119":"高集镇","411381301":"张楼乡","411381304":"夏集乡","411381305":"裴营乡","411381313":"陶营乡","411381316":"小杨营乡","411381319":"龙堰乡","411381400":"南阳市黄牛良种繁育场","411381560":"杏山旅游管理区杏山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411381.json
// module id = 1508
// module chunks = 0